export const ESTADOS_INTERES = [
  { value: "nuevo", label: "Nuevo" },
  { value: "interesado", label: "Interesado" },
  { value: "prematriculado", label: "Pre-matriculado" },
  { value: "matriculado", label: "Matriculado" },
  { value: "descartado", label: "Descartado" },
];

export const initialInteresadoForm = {
  nombres: "",
  apellidos: "",
  documento: "",
  telefono: "",
  email: "",
  fuente_origen_id: "",
  fuente_origen_nombre: "",
  empresa_origen_id: "",
  empresa_nombre: "",
  nueva_empresa_nombre: "",
  referido_por_id: "",
  estado_interes: "nuevo",
  fecha_registro: "",
};
